/**
 * Browser-only file utilities.
 *
 * ⚠️ WARNING: This module requires browser runtime (File API).
 * Do NOT import in Node.js or server-side code.
 *
 * @module @f2e/shared/browser/file
 */
/**
 * Ensures .md files carry text/markdown MIME type so MIME-based checks work consistently.
 *
 * Some browsers don't properly detect MIME types for markdown files.
 * This function normalizes the MIME type for .md files.
 *
 * ⚠️ Browser-only: Requires File API
 *
 * @param file - The file to normalize
 * @returns A new File with corrected MIME type if it's a .md file, otherwise the original file
 *
 * @example
 * ```ts
 * const file = new File(['# Hello'], 'readme.md', { type: '' })
 * const normalized = normalizeMarkdownType(file)
 * console.log(normalized.type) // 'text/markdown'
 * ```
 */
export const normalizeMarkdownType = (file) => {
    const lowerName = file.name.toLowerCase();
    if (lowerName.endsWith(".md")) {
        return new File([file], file.name, {
            type: "text/markdown",
            lastModified: file.lastModified,
        });
    }
    return file;
};
